export enum DisplayMode {
    ONLYTEXT = 'onlyText',
    ONLYICON = 'onlyIcon',
    SHOWICON = 'showIcon'
}

export type DisplayModeValues = `${DisplayMode}`;